import { ThemeProvider } from "@mui/material/styles";
import { isEmpty } from "lodash";
import { ErrorBoundary } from "react-error-boundary";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import RootErrorFallback from "./components/errors/RootErrorFallback";
import { ApiContextProvider } from "./contexts/ApiContext";
import useAuth, { AuthContextProvider } from "./contexts/AuthContext";
import { BuoyContextProvider } from "./contexts/BuoyContext";
import { SubscriptionContextProvider } from "./contexts/SubscriptionContext";
import { ToastProvider } from "./contexts/ToastContext";
import { UserContextProvider } from "./contexts/UserContext";
import { RecoilRoot } from "recoil";
import "./i18n";
import Layout from "./layout";
import Routes from "./router";
import theme from "./styles/Theme";
import { useClearCacheCtx } from "react-clear-cache";
import { useEffect } from "react";
import { InvoiceContextProvider } from "./contexts/InvoiceContext";

function Providers(props: any) {
	const { token } = useAuth();

	return (
		<>
			{isEmpty(token) ? (
				props.children
			) : (
				<ApiContextProvider key={token}>
					<UserContextProvider key={token}>
						<SubscriptionContextProvider key={token}>
							<InvoiceContextProvider key={token}>
								<BuoyContextProvider key={token}>{props.children}</BuoyContextProvider>
							</InvoiceContextProvider>
						</SubscriptionContextProvider>
					</UserContextProvider>
				</ApiContextProvider>
			)}
		</>
	);
}

const queryClient = new QueryClient();

function App() {
	const { isLatestVersion, emptyCacheStorage } = useClearCacheCtx();

	useEffect(() => {
		if (!isLatestVersion) {
			emptyCacheStorage();
			window.location.reload();
		}
	}, [isLatestVersion]);

	return (
		<RecoilRoot>
			<Layout>
				<ErrorBoundary
					FallbackComponent={RootErrorFallback}
					onReset={() => {
						window.location.reload();
					}}
				>
					<ThemeProvider theme={theme}>
						<ToastProvider>
							<QueryClientProvider client={queryClient}>
								<BrowserRouter
									future={{
										v7_startTransition: true,
										v7_relativeSplatPath: true,
									}}
								>
									<AuthContextProvider>
										<Providers>
											<Routes />
										</Providers>
									</AuthContextProvider>
								</BrowserRouter>
							</QueryClientProvider>
						</ToastProvider>
					</ThemeProvider>
				</ErrorBoundary>
			</Layout>
		</RecoilRoot>
	);
}

export default App;
